module.exports = __webpack_public_path__ + "static/img/balz909-663-370-gld.c64b75e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2025/balz909-663-370-gld.jpg
// module id = icja
// module chunks = 0